import { nanoid } from 'nanoid/non-secure';

import { USER_ID_KEY } from './constants';

export const handleAnonId = () => {
    let userId = window.localStorage.getItem(USER_ID_KEY);

    if (!userId) {
        userId = nanoid();
        window.localStorage.setItem(USER_ID_KEY, userId);
    }

    if (typeof window !== `undefined`) {
        if (window.analytics && window.analytics.user) {
            window.analytics.user().anonymousId(userId);
        }
    }

    return userId;
};
